// ============================================================
// GAME CONSTANTS
// ============================================================

export const TILE_SIZE = 8; // 8x8 pixel tiles (sprites are 8x16 = 1x2 tiles)
export const CHUNK_SIZE = 8; // tiles per chunk
export const CHUNKS_LOADED = 5;
export const VIEWPORT_TILES = CHUNKS_LOADED * CHUNK_SIZE - 12; // 28 tiles visible (reduced by 4)

export const MOVE_RATE = 10; // tiles per second
export const MOVE_INTERVAL = 1000 / MOVE_RATE; // ms between moves
export const JUMP_HEIGHT = 30; // tiles (30 for testing, normally 3)
export const MIN_JUMP_TILES = 1; // minimum jump even if up is released
export const JUMPSQUAT_DURATION = 100; // ms

// Network
export const TICK_RATE = 10; // server ticks per second
export const TICK_INTERVAL = 1000 / TICK_RATE;
export const INTERPOLATION_BUFFER_MS = 100; // client interpolation delay

// ============================================================
// TILE TYPES
// ============================================================

export enum TileType {
    SKY = 0,
    DIRT = 1,
    STONE = 2,
    GRASS = 3,
}

export const TILE_COLORS: Record<TileType, number> = {
    [TileType.SKY]: 0x87CEEB,
    [TileType.DIRT]: 0x8B4513,
    [TileType.STONE]: 0x696969,
    [TileType.GRASS]: 0x228B22,
};

// ============================================================
// PLAYER STATES
// ============================================================

export enum PlayerState {
    IDLE = 'IDLE',
    WALKING = 'WALKING',
    JUMPSQUAT = 'JUMPSQUAT',
    RISING = 'RISING',
    FALLING = 'FALLING',
    CROUCHING = 'CROUCHING',
}

// ============================================================
// NETWORK MESSAGE TYPES
// ============================================================

export enum MessageType {
    // Client -> Server
    INPUT = 'input',
    PLACE_BLOCK = 'placeBlock',
    PICKUP_BLOCK = 'pickupBlock',
    
    // Server -> Client
    WORLD_STATE = 'worldState',
    CHUNK_DATA = 'chunkData',
    PLAYER_JOINED = 'playerJoined',
    PLAYER_LEFT = 'playerLeft',
    BLOCK_UPDATE = 'blockUpdate',
}

// ============================================================
// INPUT TYPES
// ============================================================

export interface PlayerInput {
    left: boolean;
    right: boolean;
    up: boolean;
    down: boolean;
    downJustPressed: boolean;
    sequence: number; // For client prediction reconciliation
    timestamp: number;
}

// ============================================================
// NETWORK DATA TYPES
// ============================================================

export interface NetworkPlayer {
    id: string;
    x: number;
    y: number;
    state: PlayerState;
    facing: number; // -1 or 1
    isCrouching: boolean;
    isHoldingBlock: boolean;
    heldBlockType: TileType | null;
}

export interface ChunkData {
    cx: number;
    cy: number;
    tiles: number[][]; // 2D array of TileType
}

export interface BlockUpdate {
    x: number;
    y: number;
    type: TileType;
    action: 'place' | 'remove' | 'fall';
}

export interface FallingBlock {
    x: number;
    y: number;
    movedThisTick: boolean;
}
